import { getBaseMetaTitle } from '@/environments'

const PrivacyPolicy = () => import('./Main')

const route = {
  path: '/privacy',
  name: 'privacy',
  meta: {
    title: `PrivacyPolicy - ${getBaseMetaTitle}`
  },
  component: PrivacyPolicy
}

export default route
